import { Component } from '@angular/core';
import {BaseModalComponent, ClassificatorValuesQuery} from "common-shared";
import {MasterOperationModel, MasterOutputInstructionModel} from "web-shared";
import {IntegratedMasterService} from '../services/integrated-master.service'
import {ItemService} from "../../../common/item/item.service";
import {ManufacturingItemGroupService} from "../../manufactured-item-groups/manufacturing-item-group.service";

@Component({
  selector: 'app-master-output-instruction-edit-modal',
  templateUrl: './master-output-instruction-edit-modal.component.html',
})
export class MasterOutputInstructionEditModalComponent extends BaseModalComponent {
  masterInstruction: MasterOutputInstructionModel;
  masterOperation: MasterOperationModel;
  readonly = false;

  constructor(public integratedMasterService: IntegratedMasterService, public classificatorValuesQuery: ClassificatorValuesQuery, public itemService: ItemService, public itemGroupService: ManufacturingItemGroupService) {
    super();
  }

  submit() {
    this.close(this.masterInstruction, 'change');
  }

  delete() {
    this.integratedMasterService.removeMasterOutputInstruction(this.masterOperation, this.masterInstruction);
    this.close(this.masterInstruction, 'delete');
  }
}
